<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.625 2.625H3.375C2.96016 2.625 2.625 2.96016 2.625 3.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H20.625C21.0398 21.375 21.375 21.0398 21.375 20.625V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM4.3125 4.3125H7.5V19.6875H4.3125V4.3125ZM19.6875 19.6875H9V9H19.6875V19.6875ZM9 7.5V4.3125H19.6875V7.5H9Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Layout' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
